import { HHDSSimpleModal } from "./SimpleModal";

type ModalCallback = () => void;

export class ModalController {
  private static instance: ModalController;
  private modalElement: HHDSSimpleModal | null = null;
  private onOpenCallback: ModalCallback | null = null;
  private onCloseCallback: ModalCallback | null = null;

  public static getInstance(): ModalController {
    if (!ModalController.instance) {
      ModalController.instance = new ModalController();
    }
    return ModalController.instance;
  }

  public getContainer() {
    return this.modalElement;
  }

  public onOpen(callback: ModalCallback) {
    this.onOpenCallback = callback;
  }

  public onClose(callback: ModalCallback) {
    this.onCloseCallback = callback;
  }

  public setURL(url: string) {
    if (this.modalElement) this.modalElement.remove();
    this.modalElement = document.createElement("simple-modal") as HHDSSimpleModal;
    this.modalElement.setAttribute("data-url", url);
  }

  public addClassToCloseButton(className: string) {
    if (this.modalElement) {
      const closeButton = this.modalElement.querySelector('.hhds-simple-modal--close');
      if (closeButton) {
        closeButton.classList.add(className);
      }
    }
}
  public setContent(content: string) {
    if (this.modalElement) this.modalElement.remove();
    this.modalElement = document.createElement("simple-modal") as HHDSSimpleModal;
    this.modalElement.content = content;

    // Add Open callbacks
    this.modalElement.addEventListener("modal-opened", () => {
      this.onOpenCallback?.();
    });

    // Add Close callbacks
    this.modalElement.addEventListener("modal-closed", () => {
      this.modalElement = null;
      this.onCloseCallback?.();
    });
  }

  public open(content?: any) {
    if (content && this.modalElement) {
      this.setContent(content);
      this.close();
    }
    if (this.modalElement) {
      document.body.appendChild(this.modalElement);
    }
  }

  public close() {
    this.modalElement?.remove();
    this.modalElement = null;
    document.body.classList.remove("modal-open");
  }
}
